import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  showAlert: false,
  alertCallback: null,
};

const slice = createSlice({
  name: 'statuteLimitation',
  initialState: initialState,
  reducers: {
    setAlertData: (state, action) => {
      state.showAlert = action.payload.showAlert;
      state.alertCallback = action.payload.alertCallback;
    },
  },
});

export default slice.reducer;

export const {setAlertData} = slice.actions;
